import { useTheme, type ThemePreference } from '../hooks/useTheme';
import { t, type MessageKey } from '../i18n';
import './ThemeToggle.css';

const OPTIONS: Array<{ value: ThemePreference; label: MessageKey }> = [
  { value: 'system', label: 'theme.system' },
  { value: 'light', label: 'theme.light' },
  { value: 'dark', label: 'theme.dark' },
];

export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { preference, setPreference } = useTheme();

  return (
    <div className={`theme-toggle ${compact ? 'theme-toggle--compact' : ''}`} role="group" aria-label={t('theme.label')}>
      {!compact && <span className="theme-toggle__label">{t('theme.label')}</span>}
      <div className="theme-toggle__options">
        {OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`theme-toggle__btn ${preference === option.value ? 'is-active' : ''}`}
            onClick={() => setPreference(option.value)}
            aria-pressed={preference === option.value}
          >
            {t(option.label)}
          </button>
        ))}
      </div>
    </div>
  );
}
